import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'
import type { TestResultStepsResponse } from '@eggplant/types'

interface Props {
  id: string
  children?: (data: TestResultStepsResponse) => ReactElement
}

const GetAiRunStepsRequest = ({
  id,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/runs/${id}/steps`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetAiRunStepsRequest
